<template>
  <div>
    <v-btn text @click="movePhotoDialog = true">Move Photo</v-btn>
    <br />
    <v-dialog v-model="movePhotoDialog" width="600">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Move Photo</v-card-title>

        <v-autocomplete
          class="mb-3 mx-2"
          v-model="selectedAuditEvent"
          :items="auditEvents"
          item-text="drugName"
          item-value="id"
          label="Audit Event"
          @change="updateAuditSamples"
        ></v-autocomplete>
        <v-autocomplete
          class="mx-2"
          v-model="selectedAuditSample"
          :items="auditSamples"
          item-text="computedName"
          item-value="id"
          label="Audit Sample"
          :disabled="disableAuditSamples"
        ></v-autocomplete>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="savePhoto">Save</v-btn>
          <v-btn color="red darken-1" text @click="closeMovePhotoDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "MovePhoto",
  data: () => ({
    token: null,
    movePhotoDialog: false,
    auditEvents: [],
    selectedAuditEvent: null,
    auditSamples: [],
    selectedAuditSample: null,
    disableAuditSamples: false
  }),
  props: {
    photo: Object
  },
  methods: {
    getAllAuditsEvents() {
      let config = {
        url: `${this.getBaseUrl}/admin/getAllAuditEvents`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      };
      axios(config)
        .then(response => {
          if (response.status === 200) {
            this.auditEvents = response.data;
          } else {
            console.log(response.status);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getAuditSamples(auditEventId) {
      let config = {
        url: `${this.getBaseUrl}/admin/getAuditSamplesByAuditEventID/${auditEventId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      };
      axios(config)
        .then(response => {
          if (response.status === 200) {
            let samples = response.data;
            for (let i = 0; i < samples.length; i++) {
              samples[
                i
              ].computedName = `${samples[i].nth} - ${samples[i].doctorName} at ${samples[i].doctorAddress}`;
            }
            this.auditSamples = response.data;
          } else {
            console.log(response.status);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    async updateAuditSamples() {
      this.disableAuditSamples = true;
      this.auditSamples = await this.getAuditSamples(this.selectedAuditEvent);
      this.disableAuditSamples = false;
    },
    closeMovePhotoDialog() {
      this.setupForm();
      this.movePhotoDialog = false;
    },
    async setupForm() {
      this.auditEvents = await this.getAllAuditsEvents();
      this.auditSamples = await this.getAuditSamples(this.photo.AuditEventId);

      this.selectedAuditEvent = this.photo.AuditEventId;
      this.selectedAuditSample = this.photo.audit_sample_key;
    },
    savePhoto() {
      let newPhoto = this.photo;
      newPhoto.AuditEventId = this.selectedAuditEvent;
      newPhoto.audit_sample_key = this.selectedAuditSample;
      let config = {
        url: `${this.getBaseUrl}/admin/editPhoto`,
        method: "PUT",
        data: newPhoto,
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      };
      axios(config)
        .then(response => {
          if (response.status === 200) {
            location.reload();
          } else {
            alert("ERROR");
          }
        })
        .catch(err => {
          console.log(err);
          alert("ERROR");
        });
    }
  },
  mounted() {
    for (var i = 0, len = localStorage.length; i < len; ++i) {
      if (localStorage.key(i).indexOf("adal.access.token.key") !== -1) {
        this.token = localStorage.getItem(localStorage.key(i));
      }
    }
    this.setupForm();
  },
  computed: {
    getBaseUrl() {
      return this.$store.getters.getBaseUrl;
    }
  }
};
</script>

<style scoped>
</style>